import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Modal footer showing the selection count and Cancel / Link action buttons. */
export function ModalFooter(_ref) {
  var selectedCount = _ref.selectedCount,
    onCancel = _ref.onCancel,
    onLink = _ref.onLink,
    isLinkDisabled = _ref.isLinkDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-5 py-4 border-t border-sds-base-default bg-sds-base-default rounded-b-sds-400"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("label.files_selected", {
    count: selectedCount,
    defaultValue: "".concat(selectedCount, " selected")
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3"
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "link-records-cancel",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LINK_RECORDS_CANCEL);
      onCancel();
    },
    className: "h-8 px-5 rounded-sds-100 text-style-body-small-strong text-sds-brand-default bg-sds-brand-tertiary hover:bg-sds-brand-secondary transition-colors"
  }, t("button.cancel", {
    defaultValue: "Cancel"
  })), /*#__PURE__*/React.createElement("button", {
    "data-testid": "link-records-confirm",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LINK_RECORDS_CONFIRM);
      onLink();
    },
    disabled: isLinkDisabled,
    className: "h-8 px-5 rounded-sds-100 text-style-body-small-strong text-sds-brand-on-brand bg-sds-brand-default hover:opacity-90 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed"
  }, t("link", {
    defaultValue: "Link"
  }))));
}